import { BlocksIconClock } from 'blocks-nextjs/blocks-web-components/components/icon/icons/clock';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconClock = createComponent({ react: React, tagName: 'cat-icon-clock', elementClass: BlocksIconClock });
